import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';
import { render } from 'storyblok-rich-text-react-renderer';

import Accordion from 'components/shared/accordion';

const ToggleBlock = ({ blok }) => {
  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;

  return (
    <div
      className="container grid gap-5 overflow-hidden py-7 lg:grid-cols-2 lg:py-8 xl:py-10"
      {...(isAnimate
        ? {
            'data-sal': 'slide-up',
            'data-sal-duration': '1000',
            'data-sal-delay': '0',
            'data-sal-easing': 'ease',
          }
        : {})}
    >
      {blok.title && (
        <h3 className="mb-1 font-heading text-sm uppercase lg:col-span-2 lg:mb-4 lg:text-xl xl:mb-6 xl:text-2.5xl">
          {blok.title}
        </h3>
      )}
      <div className="border-b-[1px] border-[#D9D9D9]">
        {blok.blocks.map((blok) => {
          const renderedText = render(blok.content);
          return (
            <Accordion title={blok.title} subtitle={blok.subtitle} key={blok._uid}>
              <div className="prose text-sm !leading-[1.12] lg:text-lg xl:text-2xl">
                {renderedText}
              </div>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};

export default ToggleBlock;

ToggleBlock.propTypes = {
  blok: PropTypes.object.isRequired,
};
